import softDelete from '../../../abstract/actions/soft-delete';
import edit from './edit';
import send from './send';
import show from './show';
import sign from './sign';

export default {
  edit,
  sign,
  send,
  show,
  softDelete,
};
